import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/service';

/**
 * Blocks route when entity-login permissions were issued
 * and the required `data.entityPermission` key is missing.
 */
export const EntityPermissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const requiredPermission = route.data?.['entityPermission'] as
    | string
    | undefined;

  if (!requiredPermission) {
    return true;
  }

  if (!authService.canAccessEntityPermission(requiredPermission)) {
    return router.createUrlTree(['/miscellaneous/error'], {
      queryParams: { code: 403 },
    });
  }

  return true;
};
